var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"checkout__label",attrs:{"for":_vm.id}},[_c('span',{staticClass:"checkout__req"},[_vm._v(_vm._s(_vm.inputLabel))]),(_vm.isRequired)?_c('span',{staticClass:"checkout__req"},[_vm._v("*")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }